import React from "react";
import { Modal } from "react-bootstrap";
import serverHostingIcon from "../../../assets/images/262885778507Web_Hosting.gif";
import solanaIcon from "../../../assets/images/solanaIcon.svg";
import "./storingOnSolanaPlatform.css";

const StoringOnSolanaPlatform = () => {
  return (
    <div className="storingOnSolanaPlatform">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal storingSolanaDialog"
        show={true}
      >
        <Modal.Body className="storingOnSolanaPlatformBody figma-drop-shadow">
          <div className="onboardingCopyTradeContent">
            <h2 className="title">Storing on Solana</h2>
            <p className="desc">Please hold</p>
            {/* <img src={setupImage} alt="Setup Icon" className="setupImage" /> */}
            <div className="serverHostingIconWrap">
              <img
                src={serverHostingIcon}
                className="serverHostingIcon"
                alt="serverHostingIcon"
              />
            </div>
            <img
              src={solanaIcon}
              className="solanaIcon"
              alt="solanaIcon"
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default StoringOnSolanaPlatform;
